import React from 'react'

const FriendsThink = (props) => {

  return(
	<div className="fineryCard">
		<div className="fineryCardContent socialShare">
			<h2>NOW SEE WHAT YOUR FRIENDS THINK!</h2>
			<span>SHARE WITH THEM ON SOCIAL</span>
      <div className="socialShareButtons">
        <div className="socialFaceBook" onClick={props.facebookShare}></div>
        <div className="socialTwitter" onClick={props.twitterShare}></div>
      </div>
      <p>Check back every day for new looks to rate.</p>
			{props.children}
		</div>
	</div>

)
}
export default FriendsThink



// WEBPACK FOOTER //
// ./src/templates/FriendsThink.js